import React, {
  FunctionComponent,
  useEffect,
  useState,
} from "react";

import { Alert, Button, List, message } from "antd";
import * as H from 'history';

import { MainLayout } from "../common/Layouts/Main";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { useHistory } from "react-router-dom";
import { UsersList } from "./List";
import { getTranslations } from "../../features/translations/translationsUtils";
import { CogDrawer } from "../common/Drawer";
import { UploadFile } from "./UploadFile";

import styles from './students.module.scss';
import { BASE_URL } from "../../app/apiMiddleware";
import { Microservices } from "../../app/AllowedMicroservices";
import { fetchUsers, haveUsersToResendInvitations, hideModal, hideModalWithDelay, resendInvitations, selectDisplayModal, selectFilterCompanyIdForUsers, selectIsImportingUsers, selectIsResendingInvitationsStatus, showModal, UserRole } from "../../features/users/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import { DialogPopUp } from "../common/DialogPopUp";
import { getCognitoUserData } from "../../features/auth/authSlice";
import { CompanyField } from "../common/CompanyField";
import { isResettingCompany } from "../../features/company/companySlice";
import { ImportUsersNotifications } from "../common/importUsersNotifications";

interface RenderOptions {
  history: H.History,
  toggleVisibleImport: Function;
  resendInvitations: Function;
  disableResend: boolean;
  isImportingUsers: boolean;
}

interface IError {
  list: string[];
  row: string;
}

interface IRowErrors {
  [_id: string]: string[];
}

type ErrorList = IError[];

function renderOptions({
  history,
  toggleVisibleImport,
  resendInvitations,
  disableResend,
  isImportingUsers,
}: RenderOptions
) {
  return <>
    <Button
      disabled={disableResend}
      onClick={() => {
        resendInvitations();
      }}
      className="withBorder"
      type="link"
    >
      {getTranslations('USER_RESEND_INVITATION')}
    </Button>
    &nbsp;&nbsp;
    <Button
      onClick={() => {
        toggleVisibleImport();
      }}
      type="link"
      disabled={isImportingUsers}
    >
      {getTranslations('USERS_IMPORT')}
    </Button>
    &nbsp;&nbsp;
    <Button
      onClick={() => {
        history.push(`${Prefixes.user}${ActionSuffixes.new}`);
      }}
      type="primary"
    >
      {getTranslations('USERS_NEW')}
    </Button>
  </>;
}

interface IListItem {
  field: string;
  example: string;
}
const list: () => IListItem[] = () => [
  {
    field: getTranslations('USERS_EMAIL'),
    example: "xxxxxxx@xxxx.xx",
  },
  {
    field: getTranslations('USERS_NATIONAL_ID'),
    example: "xxxxxxxxxxxx",
  },
  {
    field: getTranslations('USERS_NATIONAL_ID_TYPE'),
    example: "CI o PASAPORTE",
  },
  {
    field: getTranslations('USERS_FIRST_NAME'),
    example: "xxxxxxx",
  },
  {
    field: getTranslations('USERS_SECOND_NAME'),
    example: "xxxxxxx",
  },
  {
    field: getTranslations('USERS_LAST_NAME'),
    example: "xxxxxxx",
  },
  {
    field: getTranslations('USERS_SECOND_LAST_NAME'),
    example: "xxxxxxx",
  },
  {
    field: getTranslations('USERS_BIRTH_DATE'),
    example: "DD/MM/AAAA (tipo fecha)",
  },
  {
    field: getTranslations('USERS_GENDER'),
    example: "MASCULINO o FEMENINO",
  },
  {
    field: getTranslations('USERS_CELLPHONE'),
    example: "+00000000000 (incluye el código de país)",
  },
  {
    field: getTranslations('USERS_ADDRESS'),
    example: "xxxxxxxxx",
  },
];

export const Users: FunctionComponent = () => {
  const history = useHistory();
  const [visibleImport, setVisibleImport] = useState<boolean>(false);
  const [errors, setErrors] = useState<ErrorList>([]);
  const [errorsCount, setErrorsCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [objectName, setObjectName] = useState<string>("");
  const [currentAction, setCurrentAction] = useState<string>("");
  const isModalVisible = useSelector(selectDisplayModal);
  const [companyId, setCompanyId] = useState<string>("");
  const usersToResendInvitations = useSelector(haveUsersToResendInvitations);
  const isResendingInvitations = useSelector(selectIsResendingInvitationsStatus);
  const isImportingUsers = useSelector(selectIsImportingUsers);
  const selectedCompanyId = useSelector(selectFilterCompanyIdForUsers);

  const cognitoUserData = useSelector(getCognitoUserData);
  const role = cognitoUserData ? cognitoUserData["custom:role"] : undefined;
  const userCompanyId = cognitoUserData
    ? cognitoUserData["custom:company"]
    : null;
  console.log("🚀 ~ Users ~ userCompanyId:", userCompanyId)
  useEffect(() => {
    if (userCompanyId) {
      setCompanyId(userCompanyId);
    }
  }, [userCompanyId]);

  const showCompaniesList = role === UserRole.SuperAdmin;
  const isSuperAdmin = role === UserRole.SuperAdmin;

  const toggleVisibleImport = () => {
    if (visibleImport) {
      setErrorsCount(0);
      setErrors([]);
    }
    setVisibleImport(!visibleImport);
  };
  const handleChange = (info: any) => {
    const { status } = info.file;
    if (status === "uploading") {
      setLoading(true);
      setErrors([]);
      setErrorsCount(0);
      setObjectName(getTranslations('USERS_IMPORT_STUDENTS'));
      setCurrentAction(getTranslations('USERS_IMPORT_STUDENTS_CREATED'));
      return;
    }
    if (status === "done") {
      setLoading(false);
      const {
        count,
        errors: errorsDict,
      }: {
        recordsCount: number;
        count: number;
        errors: IRowErrors;
      } = info.file.response;
      const errors: ErrorList = [];
      Object.keys(errorsDict).forEach((rowNumber) => {
        errors.push({
          list: errorsDict[rowNumber],
          row: rowNumber,
        });
      });
      setErrors(errors);
      setErrorsCount(count);
      if (errors.length === 0) {
        dispatch(showModal());
        dispatch(hideModalWithDelay());
        dispatch(fetchUsers());
        toggleVisibleImport();
      }
    } else if (status === "error") {
      setErrors([]);
      setErrorsCount(0);
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const renderLists = (errors: ErrorList, count: number) => {
    if (count === 0) {
      return (
        <React.Fragment>
          <div className={styles.infoText}>
            {getTranslations('USERS_IMPORT_DESCRIPTION')}
            <a
              href={`${BASE_URL[Microservices.COMPANY_SERVICE]
                }/../assets/user-template-import.xlsx`}
            >
              {getTranslations('USERS_IMPORT_DOWNLOAD')}
            </a>
          </div>
          <List<IListItem>
            className={styles.list}
            dataSource={list()}
            renderItem={(item, index) => {
              return (
                <List.Item key={index} className={styles.item}>
                  <div className={styles.field}>{item.field}</div>
                  <div className={styles.example}>{item.example}</div>
                </List.Item>
              );
            }}
          />
        </React.Fragment>
      );
    }
    return (
      <List<IError>
        className={styles.errorslist}
        dataSource={errors}
        renderItem={(item, index) => {
          const errorList = item.list.map((error, index) => {
            return (
              <span className={styles.error} key={index}>
                {error}
              </span>
            );
          });
          return (
            <List.Item key={index} className={styles.item}>
              <div className={styles.text}>
                {getTranslations('USERS_IMPORT_ERROR_1', [item.row])}{" "}
              </div>
              <Alert
                className={styles.errorAlert}
                message={<React.Fragment>{errorList}</React.Fragment>}
                type="error"
              />
            </List.Item>
          );
        }}
      />
    );
  };
  const isResendingBackend = useSelector(isResettingCompany);
  const onResendInvitations = () => {
    dispatch(resendInvitations(selectedCompanyId));
  };
  const url = companyId ? `${BASE_URL[Microservices.COMPANY_SERVICE]}/user/import/${companyId}` : `${BASE_URL[Microservices.COMPANY_SERVICE]}/user/import`;
  return (
    <MainLayout
      title={getTranslations('USERS_TITLE')}
      rightTopOptions={renderOptions({
        history,
        toggleVisibleImport,
        resendInvitations: onResendInvitations,
        disableResend: !usersToResendInvitations || isResendingInvitations || isResendingBackend,
        isImportingUsers,
      })}
      breadcrumbs={[getTranslations('USERS_TITLE')]}

    >
      <DialogPopUp
        name={objectName}
        action={currentAction}
        visible={isModalVisible}
        onCancel={() => {
          dispatch(hideModal());
        }}
      />
      <UsersList />

      <CogDrawer
        loading={loading}
        visible={visibleImport}
        toggleVisible={toggleVisibleImport}
        title={getTranslations('USERS_IMPORT')}
        footer={
          <div>
            <Button
              type="default"
              onClick={toggleVisibleImport}
              disabled={loading}
            >
              {getTranslations('USERS_IMPORT_CANCEL')}
            </Button>
            &nbsp;&nbsp;
          </div>
        }
      >
        {showCompaniesList ? <CompanyField
          newObject={{ company: companyId }}
          value={companyId}
          setNewObject={(data: { company: string }) => {
            console.log("🚀 ~ showCompaniesList ~ companyId:", companyId)
            setCompanyId(data.company);
          }}
          resetForm={() => { }}
        /> : null}
        <UploadFile
          onHandleChange={handleChange}
          loading={loading}
          allowedFileInfo={getTranslations('UPLOAD_FILE_DEFAULT_ALLOWED_SIZE_USER_LIST')}
          uploadUrl={url}
        />
        {renderLists(errors, errorsCount)}
      </CogDrawer>
      <div>
        {<ImportUsersNotifications companyId={isSuperAdmin ? undefined : userCompanyId} />}
      </div>
    </MainLayout>
  );
};
